export default __webpack_public_path__ + "static/media/frank.05ea503f.jpg";